var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("PageHeader", {
        attrs: {
          title: _vm.title,
          subtitle: _vm.subtitle,
          "no-padding": true,
          icon: _vm.icon,
          loading: _vm.isLoading,
        },
      }),
      _vm._v(" "),
      _c(
        "v-tabs",
        { attrs: { dark: "", grow: "", centered: "", "slider-color": "info" } },
        _vm._l(_vm.navItems, function (item, index) {
          return _c(
            "v-tab",
            {
              key: `navItem-${index}`,
              attrs: { id: item.page.name, "active-class": "" },
              on: {
                click: function ($event) {
                  return _vm.setCurrent(item.page)
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [
                _vm._v(_vm._s(item.page.icon)),
              ]),
              _vm._v(_vm._s(item.name) + "\n    "),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }